import gameiomModel from "gameiom/model/gameiom-model";
import Layers from "slotworks/graphics/layers/layers";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";

export function SetupStandardStateControlsCommand(spinname: string = "default", skipname: string = "skip", freespinsname: string = "freespins") {
    const spin = SmartUIManager.newSmartUIGroup(Layers.SmartButton, spinname, "spin");
    spin.addDisableCondition([SmartUIFlag.SKIP_COOLDOWN]);
    spin.addDisableCondition([SmartUIFlag.NO_SKIP]);
    spin.addDisableCondition([SmartUIFlag.BONUS]);
    spin.addDisableCondition([SmartUIFlag.REPLAY]);
    spin.addDisableCondition([SmartUIFlag.PROMPT]);
    spin.addDisableCondition([SmartUIFlag.MENU]);
    spin.addDisableCondition([SmartUIFlag.GAMBLE_UI]);
    spin.addDisableCondition([SmartUIFlag.EXTERNAL_DISABLE]);

    let skip = spin;
    if (Layers.SmartButton.hasScene(skipname)) {
        skip = SmartUIManager.newSmartUIGroup(Layers.SmartButton, skipname, "skip");
        skip.addDisableCondition([SmartUIFlag.NO_SKIP]);
        skip.addDisableCondition([SmartUIFlag.PROMPT]);
        skip.addDisableCondition([SmartUIFlag.BONUS]);
        skip.addDisableCondition([SmartUIFlag.EXTERNAL_DISABLE]);
    }

    const cancel = SmartUIManager.newSmartUIGroup(Layers.SmartButton, "auto");
    if (gameiomModel.disableSpinSkip) {
        cancel.addDisableCondition([SmartUIFlag.NO_SKIP]);
    }

    let freespins;
    if (Layers.SmartButton.hasScene(freespinsname)) {
        freespins = SmartUIManager.newSmartUIGroup(Layers.SmartButton, freespinsname, "freespins_skip");
        freespins.addDisableCondition([SmartUIFlag.FREE_SPINS, SmartUIFlag.BONUS]);
        freespins.addDisableCondition([SmartUIFlag.EXTERNAL_DISABLE]);
        freespins.addDisableCondition([SmartUIFlag.NO_SKIP]);
    }

    SmartUIManager.addAutoShowGroupCondition(skip, []);
    SmartUIManager.addAutoShowGroupCondition(spin, [SmartUIFlag.IDLE]);
    SmartUIManager.addAutoShowGroupCondition(skip, [SmartUIFlag.SKIP_COOLDOWN]);
    SmartUIManager.addAutoShowGroupCondition(skip, [SmartUIFlag.BONUS]);
    SmartUIManager.addAutoShowGroupCondition(skip, [SmartUIFlag.AWAITING_RESPONSE], [SmartUIFlag.AUTO_SPIN]);
    SmartUIManager.addAutoShowGroupCondition(skip, [SmartUIFlag.REPLAY]);
    SmartUIManager.addAutoShowGroupCondition(skip, [SmartUIFlag.PROMPT]);
    SmartUIManager.addAutoShowGroupCondition(cancel, [SmartUIFlag.AUTO_SPIN], [SmartUIFlag.FREE_SPINS, SmartUIFlag.BONUS]);
    SmartUIManager.addAutoShowGroupCondition(skip, [SmartUIFlag.AUTO_SPIN, SmartUIFlag.BONUS]);
    SmartUIManager.addAutoShowGroupCondition(skip, [SmartUIFlag.AUTO_SPIN, SmartUIFlag.PROMPT]);
    SmartUIManager.addAutoShowGroupCondition(freespins || skip, [SmartUIFlag.FREE_SPINS]);
}
